import classes from './SuccessMessage.module.css'


const SuccessMessage = ({message}:{message: string}) => {
    return (
        <div>
            <p className={classes.success__message}>{message}</p>
        </div>
    
    
    )
}


export default SuccessMessage